



























import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { IEditableFormatQuestionnaireSubmissionPseudonymization } from "../../../../../../domain/editableFormat";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class FormatQuestionnaireSubmissionPseudonymizationPropertyEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditableFormatQuestionnaireSubmissionPseudonymization) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditableFormatQuestionnaireSubmissionPseudonymization) => T, defaultValue: T) => T;

  get marker(): boolean {
    return this.readPropertyOrDefault(s => s.marker, false);
  }

  set marker(value: boolean) {
    this.writePropertyWhenValid(s => s.marker = value);
  }

  get format(): string {
    return this.readPropertyOrDefault(s => s.format, "");
  }

  set format(value: string) {
    this.writePropertyWhenValid(s => s.format = value);
  }

  get formatOptions(): StandardOption<string>[] {
    return [
      new StandardOption<string>("masked", "masked"),
      new StandardOption<string>("hmac-sha256", "hmac-sha256"),
      new StandardOption<string>("null", "null"),
      new StandardOption<string>("date-shift", "date-shift"),
      new StandardOption<string>("rand-value", "rand-value"),
      new StandardOption<string>("aes-cbc128", "aes-cbc128"),
    ];
  }

  get target(): string {
    return this.readPropertyOrDefault(s => s.target, "");
  }

  set target(value: string) {
    this.writePropertyWhenValid(s => s.target = value);
  }

  get type(): string {
    return this.readPropertyOrDefault(s => s.type, "");
  }

  set type(value: string) {
    this.writePropertyWhenValid(s => s.type = value);
  }

  get typeOptions(): StandardOption<string>[] {
    return [
      new StandardOption<string>("decimal", "decimal"),
      new StandardOption<string>("integer", "integer"),
      new StandardOption<string>("date", "date"),
      new StandardOption<string>("dateTime", "dateTime"),
      new StandardOption<string>("time", "time"),
      new StandardOption<string>("string", "string"),
      new StandardOption<string>("Coding", "Coding"),
    ];
  }

  @Emit()
  deleteProperty() {}
}
